var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('input',{ref:"autocomplete",staticClass:"input-style",attrs:{"type":"text"},domProps:{"value":_vm.address = _vm.initialAddress},on:{"input":function($event){_vm.address = $event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }